import { Indicator, Item } from '@radix-ui/react-radio-group';
import clsx from 'clsx';
import type { FunctionComponent, ReactNode } from 'react';

import { IconCheckmark1Small } from '../icons';

export type RadioGroupItemProps = {
    readonly id?: string;
    readonly disabled?: boolean;
    readonly label: ReactNode;
    readonly value: string;
};

export const RadioGroupItem: FunctionComponent<RadioGroupItemProps> = ({ id, disabled, label, value }) => {
    const itemId = id ?? `radio-${value}`;

    return (
        <label
            className={clsx(
                'inline-flex items-center gap-xs ml-0 mr-0 px-m py-xs bg-surface-subtle rounded-md select-none font-sans',
                'has-[[data-state=checked]]:bg-surface-interactive',
                disabled === true ? 'cursor-default opacity-50 pointer-events-none' : 'cursor-pointer',
            )}
            htmlFor={itemId}
        >
            <Item
                className="appearance-none bg-transparent border-none"
                disabled={disabled === true}
                id={itemId}
                value={value}
            >
                <div
                    className={clsx(
                        'flex items-center justify-center relative',
                        'h-[14px] w-[14px] rounded-full border-[1.5px] border-border-control',
                        '[[data-state=checked]>&]:border-accent',
                    )}
                >
                    <Indicator
                        className={clsx(
                            'flex items-center justify-center',
                            'h-full w-full rounded-full bg-accent',
                            '[&_svg]:text-on-control-selected [&_svg]:fill-on-control-selected',
                        )}
                    >
                        <IconCheckmark1Small />
                    </Indicator>
                </div>
            </Item>
            <span className="text-text-secondary cursor-inherit">{label}</span>
        </label>
    );
};
